module.exports = __webpack_public_path__ + "static/media/IMG_2554.de2bca7e.JPG";